"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var client_1 = require("@apollo/client");
var collectedFilters_1 = require("../../../../common/service/collectedFilters");
var TransactionErrorTypes_1 = require("../../../../common/enum/TransactionErrorTypes");
var initPayment_1 = require("../graphql/mutations/initPayment");
var globalTypes_1 = require("../../../../__generated__/globalTypes");
var globalTypes_2 = require("../../../../__generated__/globalTypes");
var errorHandler_1 = require("../../../../gql/common/service/errorHandler");
var StockErrorTypes_1 = require("../../../checkout4/enum/StockErrorTypes");
exports.usePayment2C2P = function (deal, loading) {
    var token = collectedFilters_1.default().filters.token;
    var initPayment = client_1.useMutation(initPayment_1.default.INITIALIZE_PAYMENT)[0];
    var _a = react_1.useState(null), initData = _a[0], setInitData = _a[1];
    var _b = react_1.useState(null), initError = _b[0], setInitError = _b[1];
    var _c = react_1.useState(false), btnLoading = _c[0], setBtnLoading = _c[1];
    var _d = react_1.useState(false), isPaymentFailed = _d[0], setIsPaymentFailed = _d[1];
    var _e = react_1.useState(false), isTransactionComplete = _e[0], setIsTransactionComplete = _e[1];
    var _f = react_1.useState(true), isStatusLoading = _f[0], setIsStatusLoading = _f[1];
    var _g = react_1.useState(false), softLocked = _g[0], setSoftLocked = _g[1];
    var _h = react_1.useState(''), softLockedErrorMsg = _h[0], setSoftLockedErrorMsg = _h[1];
    var _j = react_1.useState(false), isErrorPaymentInitSoftLock = _j[0], setErrorPaymentInitSoftLock = _j[1];
    var handlePayment = function () { return __awaiter(void 0, void 0, void 0, function () {
        var currentPaymentType;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setInitError(null);
                    setBtnLoading(true);
                    localStorage.setItem('lastPaymentStatus', TransactionErrorTypes_1.TransactionErrorTypes.NONE);
                    if (isPaymentFailed) {
                        setIsPaymentFailed(false);
                    }
                    currentPaymentType = deal.journeyType === globalTypes_1.JourneyType.online_order ? globalTypes_2.PaymentType.order_car : globalTypes_2.PaymentType.reservation_fee;
                    return [4 /*yield*/, initPayment({ variables: { identifier: token, paymentType: currentPaymentType } })
                            .then(function (initData) {
                            setInitData(initData.data.initPayment);
                            setBtnLoading(false);
                        })
                            .catch(function (e) {
                            var _a, _b, _c;
                            var setSoftLockedError = errorHandler_1.default.handleSoftLock(e);
                            setBtnLoading(false);
                            setInitError(e);
                            setSoftLocked((_a = setSoftLockedError) === null || _a === void 0 ? void 0 : _a.isStockLocked);
                            setSoftLockedErrorMsg(((_b = setSoftLockedError) === null || _b === void 0 ? void 0 : _b.translation) || '');
                            if ((_c = setSoftLockedError.path) === null || _c === void 0 ? void 0 : _c.includes(StockErrorTypes_1.StockErrorTypes.INIT_PAYMENT)) {
                                setErrorPaymentInitSoftLock(true);
                            }
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handlePaymentPostMessages = function (event) {
        var _a;
        var paymentResult = ((_a = event) === null || _a === void 0 ? void 0 : _a.data).paymentResult;
        if (paymentResult) {
            var respCode = paymentResult.respCode;
            if (respCode == '2000') {
                localStorage.setItem('isTransactionComplete', 'true');
                setIsTransactionComplete(true);
            }
        }
    };
    var handleCloseSoftLockModal = function (shouldOpen) {
        if (!shouldOpen) {
            setSoftLocked(false);
            setSoftLockedErrorMsg('');
            setErrorPaymentInitSoftLock(false);
        }
    };
    window.addEventListener('message', handlePaymentPostMessages);
    react_1.useEffect(function () {
        var _a;
        var status = (_a = deal) === null || _a === void 0 ? void 0 : _a.status;
        if (status === TransactionErrorTypes_1.TransactionErrorTypes.FAILED) {
            setIsPaymentFailed(true);
        }
        if (status === TransactionErrorTypes_1.TransactionErrorTypes.AUTHORIZED) {
            setIsTransactionComplete(true);
        }
        if (status && !loading) {
            setIsStatusLoading(false);
            localStorage.setItem('lastPaymentStatus', status);
        }
    }, [deal, loading]);
    return {
        initData: initData,
        initError: initError,
        btnLoading: btnLoading,
        isPaymentFailed: isPaymentFailed,
        handlePayment: handlePayment,
        isTransactionComplete: isTransactionComplete,
        isStatusLoading: isStatusLoading,
        softLocked: softLocked,
        softLockedErrorMsg: softLockedErrorMsg,
        isErrorPaymentInitSoftLock: isErrorPaymentInitSoftLock,
        handleCloseSoftLockModal: handleCloseSoftLockModal,
    };
};
